import _regeneratorRuntime from 'babel-runtime/regenerator';

var _this = this;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import Paper from '@material-ui/core/Paper';
import FormHelperText from '@material-ui/core/FormHelperText';
import FilesList from './FilesList';
import { sleep, getFileObject } from './utils';
import styles from './styles';

var Uploods = function Uploods(_ref) {
  var onChange = _ref.onChange,
      width = _ref.width,
      containerStyle = _ref.containerStyle,
      inputStyle = _ref.inputStyle,
      hideList = _ref.hideList,
      accept = _ref.accept,
      maxSize = _ref.maxSize,
      elevation = _ref.elevation,
      text = _ref.text,
      dragActiveText = _ref.dragActiveText,
      unsupportedText = _ref.unsupportedText;

  var _useState = useState([]),
      files = _useState[0],
      setFiles = _useState[1];

  var _useState2 = useState(text),
      message = _useState2[0],
      setMessage = _useState2[1];

  return React.createElement(
    Paper,
    {
      style: _extends({ width: width }, styles.container, containerStyle),
      elevation: elevation
    },
    React.createElement(
      Dropzone,
      {
        acceptedFiles: accept,
        maxSize: maxSize * 1000,
        onDropRejected: _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  setMessage(unsupportedText);
                  _context.next = 3;
                  return sleep(3000);

                case 3:
                  setMessage(text);

                case 4:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        })),
        onDrop: function () {
          var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(accepted) {
            var parsedFiles, filesList;
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return Promise.all(accepted.map(getFileObject));

                  case 2:
                    parsedFiles = _context2.sent;
                    filesList = [].concat(files, parsedFiles);

                    setFiles(filesList);
                    onChange(filesList);

                  case 6:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _callee2, _this);
          }));

          return function (_x) {
            return _ref3.apply(this, arguments);
          };
        }()
      },
      function (_ref4) {
        var getRootProps = _ref4.getRootProps,
            getInputProps = _ref4.getInputProps,
            isDragActive = _ref4.isDragActive;
        return React.createElement(
          'div',
          _extends({}, getRootProps(), {
            style: _extends({}, styles.dropzone, inputStyle)
          }),
          React.createElement('input', getInputProps()),
          React.createElement(
            FormHelperText,
            { error: message === unsupportedText },
            isDragActive ? dragActiveText : message
          )
        );
      }
    ),
    !hideList && React.createElement(FilesList, { files: files, setFiles: setFiles })
  );
};

Uploods.propTypes = process.env.NODE_ENV !== "production" ? {
  onChange: PropTypes.func.isRequired,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  containerStyle: PropTypes.object,
  inputStyle: PropTypes.object,
  hideList: PropTypes.bool,
  accept: PropTypes.arrayOf(PropTypes.string),
  maxSize: PropTypes.number,
  elevation: PropTypes.number,
  text: PropTypes.string,
  dragActiveText: PropTypes.string,
  unsupportedText: PropTypes.string
} : {};

Uploods.defaultProps = {
  width: '100%',
  maxSize: 10000,
  elevation: 0,
  text: 'Drag some files here, or click to select files',
  dragActiveText: 'Drop here!',
  unsupportedText: 'Unsupported File...'
};

export default Uploods;